<template>
  <div>
    <div class="title">角色管理</div>
    <div class="container">
      <el-button type="primary" class="addbtn" @click="addrole" v-if="addroleshow">添加角色</el-button>
      <el-table :data="roleData" stripe border style="margin-top:20px">
        <el-table-column prop="roleName" label="角色"></el-table-column>
        <!-- <el-table-column prop="userNum" label="用户数量" align="center"></el-table-column> -->
        <el-table-column prop="phone" label="权限分配" align="center" v-if="editroleshow">
          <template slot-scope="scope">
            <div class="detailcolor" v-if="scope.row.id===1">无</div>
            <div
              class="detailcolor"
              @click="userpower(scope.row)"
              style="cursor:pointer"
              v-else
            >选择权限</div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" align="right" v-if="deletroleshow">
          <template slot-scope="scope">
            <div>
              <span>
                <img
                  src="../images/delete.png"
                  @click="deleterole(scope.row)"
                  style="cursor:pointer"
                />
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加角色" :visible.sync="roleVisible" width="300px" :show-close="false">
      <div slot="title">
        <p>添加角色</p>
        <i class="el-icon-error" @click="addVisible = false"></i>
      </div>
      <div class="addroleline">角色名称 :</div>
      <div>
        <el-input v-model="rolename" placeholder="请输入角色名称" style="width:100%"></el-input>
      </div>
      <div class="addroleline">英文简称 :</div>
      <div>
        <el-input v-model="rolekey" placeholder="请输入英文简称" style="width:100%"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleVisible = false">取 消</el-button>
        <el-button type="primary" @click="addrolebtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择权限" :visible.sync="choiceVisible" width="300px" :show-close="false" @close="closeroleTree">
      <div slot="title">
        <p  @click="choiceVisible = true">选择权限</p>
        <i class="el-icon-error" @click="choiceVisible = false"></i>
      </div>
      <el-tree 
        :props="props"
        :data="allpower"
        node-key="id"
        show-checkbox
        ref="tree"
        :default-checked-keys="nodekeylist"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeroleTree">取 消</el-button>
        <el-button type="primary" @click="changerolebtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { messages } from '@/util/resetMessage.js';
import {
  getrolelist,
  addrole,
  deleterole,
  // getroleMenuTreeselect,
  // updateroleMenu,
  powerroletypetree,
  powertree,
  addrolepoewr
  // addlogoperate
} from "../axios/api.js";
export default {
  data() {
    return {
      editroleshow: false,
      addroleshow: false,
      roleVisible: false,
      deletroleshow:false,
      rolename: "",
      rolekey: "",
      roleData: [],
      choiceVisible: false,
      roleId:null,
      allpower:[],
      props: {
        label: "name",
        value: "id"
      },
      nodekeylist:[]

    };
  },
  methods: {
    getpowertree(){
      powertree().then(res=>{
        console.log(res);
        if (res.code=='200') {
          this.allpower=res.data
        }
      })
    },
    getroletree(){
      powerroletypetree(Number(this.roleId)).then(res=>{
        console.log(res);
        if (res.code==200) {
          this.nodekeylist= res.data.filter(i=>i.id).map(i=>i.id);
          console.log(this.nodekeylist);
          this.choiceVisible = true;

        }
      })
    },
    closeroleTree(){
      this.allpower=[]
      this.nodekeylist=[]
      this.choiceVisible = false;
    },
    //打开添加角色弹窗
    addrole() {
      this.rolename = null;
      this.roleVisible = true;
    },

    //获取角色列表
    getrole() {
      getrolelist([]).then(res => {
        console.log(res.rows);
        this.roleData = res.rows;
      });
    },

    powerlist() {
      const arr = localStorage.getItem("permissionList")
      var newArr=JSON.parse(arr.replace(/\n/g,"\\n").replace(/\r/g,"\\r")).filter(i=>i.type==="B");

      for (var i in newArr) {
        if (newArr[i].id == 33) {
          this.addroleshow = true;
        }
        if (newArr[i].id == 36) {
          this.editroleshow = true;
        }
        if (newArr[i].id == 34) {
          this.deletroleshow = true;
        }

      }
    },

    getTreeData(data) {
      // 循环遍历json数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }

        if (!data[i].adcode) {
          data[i].adcode = data[i].id;
        }
      }
      return data;
    },

    //删除角色
    deleterole(e) {
      console.log(e);
      this.$confirm("您确定要删除该角色吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            deleterole([e.id]).then(res => {
              if (res && res.code === 200) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });

                // const params = {
                //   userName: localStorage.getItem("username"),
                //   content: `${localStorage.getItem("username") +
                //     "删除了" +
                //     e.name +
                //     "角色"}`,
                //   type: 4,
                //   operateTime: this.$moment(new Date()).format(
                //     "yyyy-MM-DD HH:mm:ss"
                //   ),
                //   platform: 7,
                //   module: "角色管理",
                //   userId: this.unitName
                // };
                // addlogoperate(params).then(res => {
                //   console.log(res.data);
                //   // this.tableData = res.data.list;
                //   // this.totalpage = res.data.total;
                // });
                this.getrole();
              }
            });
          }
        }
      });
    },

    //确认添加角色
    addrolebtn() {
      if (!this.rolename) {
        this.$message({
          message: "请输入角色名称",
          type: "error"
        });
      } else {
        const params = {
          roleName: this.rolename,
          roleKey: this.rolekey
        };
        addrole(params).then(res => {
          if (res && res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });

            // const params = {
            //   userName: localStorage.getItem("username"),
            //   content: `${localStorage.getItem("username") +
            //     "添加了" +
            //     this.rolename +
            //     "角色"}`,
            //   type: 3,
            //   operateTime: this.$moment(new Date()).format(
            //     "yyyy-MM-DD HH:mm:ss"
            //   ),
            //   platform: 7,
            //   module: "角色管理"
            // };
            // addlogoperate(params).then(res => {
            //   console.log(res.data);
            //   // this.tableData = res.data.list;
            //   // this.totalpage = res.data.total;
            // });

            this.getrole();
            this.roleVisible = false;
            this.rolename = null;
          } else {
            console.log(res.message);
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        });
      }
    },

    //确认修改角色权限 
    changerolebtn() {
      // console.log(this.$refs.tree.getCheckedKeys());
      // console.log([
      //   // ...this.$refs.tree.getHalfCheckedKeys(),
      //   ...this.$refs.tree.getCheckedKeys()
      // ]);
      const params = {
        roleId: this.roleId,
        permissionIdList:[
          // ...this.$refs.tree.getHalfCheckedKeys(),
          ...this.$refs.tree.getCheckedKeys()
        ]
      };
      console.log(params)
      addrolepoewr(params).then(res=>{
        console.log(res);
        if (res.code==200) {
          messages.success('修改成功')
          this.allpower=[];
          this.nodekeylist=[]
          this.choiceVisible = false;
        }
      })

    },
    handleCheckChange(){},
    //打开角色权限弹窗
    userpower(e) {
      console.log(e);
      this.roleId=e.id
      this.getroletree()
      this.getpowertree()
    }
  },
  created() {
    this.getrole();
    this.powerlist();
    this.getpowertree()
  }
};
</script>

<style scoped>
.addroleline {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
.title {
  text-align: left;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.container {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  text-align: left;
  border-radius: 3px;
  margin-top: 24px;
}
</style>